import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import RegisterForm from './RegisterForm';

const RegisterPage = () => {
  const { theme } = useTheme();
  
  return (
    <div 
      className="min-h-screen flex items-center justify-center" 
      style={{ backgroundColor: theme.mainPanelBg }}
    >
      <div className="max-w-md w-full p-8 rounded-lg">
        <h1 
          className="text-3xl font-bold mb-8 text-center"
          style={{ color: theme.mainPanelText }}
        >
          Create an Account
        </h1>
        <RegisterForm />
      </div>
    </div>
  );
};

export default RegisterPage;